import { useToast } from "@chakra-ui/react";
import { ToastComponent } from "@/components/ToastComponent";


const id = "singleton-toast";

export const useSnackbar = () => {

    const t = useToast({
        position: 'top-right',
        containerStyle: {
            marginTop: '100px',
        }
    });

    const message = (message: string, type: 'success' | 'error' = 'success') => {
        if (!t.isActive(id)) {
            t({
                id,
                render: () => <ToastComponent message={message} type={type} />
            })
        }

    }

    return {
        message,
    }
}